module.exports = __webpack_public_path__ + "img/pending-clock-alert-outline.1616f18c.svg";